import { render } from "./RegleDeConfidentialitePage.vue?vue&type=template&id=7d4a3676&ts=true"
import script from "./RegleDeConfidentialitePage.vue?vue&type=script&lang=ts"
export * from "./RegleDeConfidentialitePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__